import ColdIconSvg from "./cold-lead.svg?url";
import WarmIconSvg from "./warm-lead.svg?url";
import HotIconSvg from "./hot-lead.svg?url";
import RemittanceIconSvg from "./remittance-product.svg?url";
import InsuranceIconSvg from "./insurance-product.svg?url";
import FinancingIconSvg from "./financing-product.svg?url";
import ReferralIconSvg from "./referral-product.svg?url";
import ReKYCIconSvg from "./rekyc-product.svg?url";
import DropdownDetailsIconSvg from "./view-full-details.svg?url";
import DropdownReminderIconSvg from "./add-reminder.svg?url";
import DropdownInteractionIconSvg from "./add-interactions.svg?url";
import ReminderClockIconSvg from "./clock.svg?url";
import ReminderElipsesSvg from "./sidebar-reminder-ellipses.svg?url";
import InteractionCallIconSvg from "./interactions-call.svg?url";
import InteractionEmailIconSvg from "./interactions-email.svg?url";
import InteractionEventIconSvg from "./interactions-event.svg?url";
import InteractionTextIconSvg from "./interactions-text.svg?url";
import InteractionSocMedIconSvg from "./interactions-socmed.svg?url";
import FileUploadIconSvg from "./file-upload.svg?url";

export const ColdIcon = ColdIconSvg;
export const WarmIcon = WarmIconSvg;
export const HotIcon = HotIconSvg;
export const RemittanceIcon = RemittanceIconSvg;
export const InsuranceIcon = InsuranceIconSvg;
export const FinancingIcon = FinancingIconSvg;
export const ReferralIcon = ReferralIconSvg;
export const ReKYCIcon = ReKYCIconSvg;
export const DropdownDetailsIcon = DropdownDetailsIconSvg;
export const DropdownReminderIcon = DropdownReminderIconSvg;
export const DropdownInteractionIcon = DropdownInteractionIconSvg;
export const ReminderClockIcon = ReminderClockIconSvg;
export const ReminderElipses = ReminderElipsesSvg;
export const InteractionCallIcon = InteractionCallIconSvg;
export const InteractionEmailIcon = InteractionEmailIconSvg;
export const InteractionEventIcon = InteractionEventIconSvg;
export const InteractionTextIcon = InteractionTextIconSvg;
export const InteractionSocMedIcon = InteractionSocMedIconSvg;
export const FileUploadIcon = FileUploadIconSvg;